/**
 * Collection of design tokens that determine the thickness of lines, outlines, and other graphical
 * elements to ensure visual consistency.
 */ const strokeWidths = {
    none: 0,
    regular: 1,
    thick: 2
};

export { strokeWidths };
//# sourceMappingURL=stroke-width.js.map
